import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "container-fluid mt--6"
};
import Collapse from '@/templates/argon-core/Collapse/Collapse.vue';
import CollapseItem from '@/templates/argon-core/Collapse/CollapseItem.vue';
import Card from '@/templates/argon-core/Cards/Card.vue';
export default {
  __name: 'AppgDetail',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Card, {
        "footer-classes": "pb-2"
      }, {
        default: _withCtx(() => [_createVNode(Collapse, {
          "active-index": 0
        }, {
          default: _withCtx(() => [_createVNode(CollapseItem, {
            class: "border-radius",
            name: "1"
          }, {
            title: _withCtx(() => [_renderSlot(_ctx.$slots, "title")]),
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "main")]),
            _: 3
          })]),
          _: 3
        })]),
        _: 3
      })])]);
    };
  }
};